// Features Grid — MEELZ-only Builder component. Extracted from the REAL,
// separate, always-live `<Features />` component (meelz-client-v2's
// src/components/features.tsx), rendered directly below <HeroSection/> in
// page.tsx — NOT part of the hero card at all. This is a genuine
// architectural correction: earlier work incorrectly nested this content
// inside HERO_SCHEMA as features/featuresColumns/featuresIconPosition.
//
// MEELZ-only: E4F/CK have no equivalent separate section — their real
// hero designs nest an identical-content features grid INSIDE the hero
// card itself, which stays represented in HERO_SCHEMA for those 2 brands
// only (see heroLayouts.constants.js). This component is gated to MEELZ in
// COMPONENT_REGISTRY (ClientBuilderPanel.js), not registered at all for
// E4F/CK builds.
//
// Real text confirmed from meelz-client-v2/src/messages/en.json
// ("features" namespace): "Fresh Ingredients" / "Every Day On Time
// Delivery" / "Flexible Meal Plans" / "Precise Nutrient Calculation" —
// exact casing corrected vs. the earlier hero-nested copy.
export const FEATURES_GRID_ITEM_FIELDS = [
    { field: "icon",  label: "Icon", type: "icon" },
    { field: "label", label: "Label", translatable: true, wrapControl: true },
];
export const FEATURES_GRID_NEW_ITEM = { icon: "StarOutlined", label: { en: "New Feature" } };

// Only one real layout exists — MEELZ's actual live features.tsx. No
// per-brand layout picker is meaningful here (E4F/CK don't have this
// registry entry at all), but the `layouts` map shape is kept consistent
// with every other component for the same generic buildDefaultEntry/
// mergeEntry machinery to apply unchanged.
export const FEATURES_GRID_LAYOUT_MEELZ_DEFAULT_PROPS = {
    backgroundColor: "#FFFBF4",
    primaryColor:    "#573121",
    items: [
        { icon: "AppleOutlined",     label: { en: "Fresh Ingredients" } },
        { icon: "TruckOutlined",     label: { en: "Every Day On Time Delivery" } },
        { icon: "CalendarOutlined",  label: { en: "Flexible Meal Plans" } },
        { icon: "DashboardOutlined", label: { en: "Precise Nutrient Calculation" } },
    ],
};

export const FEATURES_GRID_LAYOUTS = {
    meelz: { label: "Layout 1", defaultProps: FEATURES_GRID_LAYOUT_MEELZ_DEFAULT_PROPS },
};

export const FEATURES_GRID_SCHEMA = [
    { key: "backgroundColor", label: "Background color", type: "color" },
    { key: "primaryColor",    label: "Icon/text color",  type: "color" },
    {
        key:            "items",
        label:          "Features",
        type:           "cards",
        fields:         FEATURES_GRID_ITEM_FIELDS,
        newItemDefault: FEATURES_GRID_NEW_ITEM,
    },
];
